import { render, staticRenderFns } from "./Konzessionsthemen.vue?vue&type=template&id=4989f1c0&scoped=true&"
import script from "./Konzessionsthemen.vue?vue&type=script&lang=js&"
export * from "./Konzessionsthemen.vue?vue&type=script&lang=js&"
import style0 from "./Konzessionsthemen.vue?vue&type=style&index=0&id=4989f1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989f1c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VSelect,VTimeline,VTimelineItem})
